import UserRow from './Parts/UserRow';

type UsersListProps = {
  users: any[];
  now: number;
  t: any;
  onSelect: (userId: string) => void;
};

export default function UsersList({ users, now, t, onSelect }: UsersListProps) {
  return (
    <div className="users-list">
      {users.map((user) => (
        <UserRow
          key={user.id}
          user={user}
          now={now}
          t={t}
          onSelect={() => onSelect(user.id)}
        />
      ))}
    </div>
  );
}
